import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConnectProvider } from '../providers/account/auth-connect';
import { UtilitiesProvider } from '@providers/utilities-provider';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(
    private authProvider: AuthConnectProvider,
    private router: Router,
    private utilitiesProvider: UtilitiesProvider,
  ) {}

  async canActivate(): Promise<boolean> {
    const settings = AuthConnectProvider.getSettings();
    const href = AuthConnectProvider.cleanUrl();
    const isBrowser = this.utilitiesProvider.getCurrentPlatform();
    if (!settings?.appClientId && isBrowser) {
      this.router.navigate(['login']);
    }
    this.authProvider.configureAuthConnect(
      settings.appClientId,
      href,
      href,
      settings.region,
      'CURRENT',
    );

    const isAuth = await this.authProvider
      .isAuthenticated()
      .then((res: boolean) => res);
    // const isExpired = await this.authProvider.isExpired().then( (res: boolean ) => res );
    if (!isAuth) {
      this.router.navigate(['login']);
    }

    return isAuth;
  }
}
